import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './DeleteAccountPage.css';

const DeleteAccountPage = () => {
  return (
    <div className="delete-account-container">
      <Helmet>
        <title>Delete Account — VOIA Travel</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Navbar />

      <div className="delete-account-content">
        <h1 className="delete-account-title">VOIA Travel – Account Deletion Request</h1>

        <section className="delete-account-section">
          <p>
            If you would like to delete your VOIA Travel account and all associated data, you can submit a deletion request at any time.
          </p>
        </section>

        <section className="delete-account-section">
          <h2>How to Request Account Deletion</h2>
          <p>To delete your account, please email us at:</p>
          <p className="delete-account-email">
            <strong>admin@voiatravel.com</strong>
            <br />
            <span className="delete-account-email-note">(subject: Delete My VOIA Account)</span>
          </p>
          <p>Please include:</p>
          <ul>
            <li>The email address associated with your VOIA account</li>
            <li>Confirmation that you want all data associated with your account permanently deleted</li>
          </ul>
          <p>We will process your request within 30 days.</p>
        </section>

        <section className="delete-account-section">
          <h2>What Data Will Be Deleted</h2>
          <p>When your deletion request is processed, the following data will be permanently removed:</p>
          <ul>
            <li>Your VOIA account (Firebase Authentication)</li>
            <li>All trip data and itineraries</li>
            <li>Uploaded photos or files</li>
            <li>Notes and travel logs</li>
            <li>Any other content you created inside the app</li>
          </ul>
          <p><strong>This data cannot be recovered after deletion.</strong></p>
        </section>

        <section className="delete-account-section">
          <h2>What Data May Be Retained</h2>
          <p>We may keep the following for legal and security purposes:</p>
          <ul>
            <li>Aggregated or anonymized analytics data (not linked to your identity)</li>
            <li>Records required to comply with legal obligations</li>
          </ul>
          <p>This retained data cannot be used to identify you.</p>
        </section>

        <section className="delete-account-section">
          <h2>Questions</h2>
          <p>If you have any questions about account deletion or data handling, contact us at:</p>
          <p className="delete-account-contact">
            <strong>admin@voiatravel.com</strong>
          </p>
        </section>

        <div className="delete-account-footer-actions">
          <Link to="/" className="delete-account-back-link">← Back to Home</Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DeleteAccountPage;

